import { useSentry } from "./useSentry";

const SentryInitialiser = () => {
  useSentry();
  return <></>;
};

export { SentryInitialiser };
